export default __webpack_public_path__ + "assets/models/eed63bacab40f69e257860bbd00437c3.glb";